import { defineMessage } from 'react-intl'

export const MAX_TEAM_NAME_LENGTH = 40

export const TEAM_SIZE_OPTIONS = [
  {
    title: defineMessage({
      id: 'boarding.createOrg.teamSizeOptions.justMe',
      defaultMessage: 'Just me',
    }),
    value: '1',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.teamSizeOptions.2-10',
      defaultMessage: '2-10 people',
    }),
    value: '2',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.teamSizeOptions.11-50',
      defaultMessage: '11-50 people',
    }),
    value: '11',
  },

  {
    title: defineMessage({
      id: 'boarding.createOrg.teamSizeOptions.51-200',
      defaultMessage: '51-200 people',
    }),
    value: '51',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.teamSizeOptions.200+',
      defaultMessage: '200+ people',
    }),
    value: '200',
  },
].map((x) => ({ ...x, id: x.value }))

export const REMOTE_OPTIONS = [
  {
    title: defineMessage({
      id: 'boarding.createOrg.remoteOptions.notRemote',
      defaultMessage: 'Not remote',
    }),
    subtitle: defineMessage({
      id: 'boarding.createOrg.remoteOptions.notRemoteSubtitle',
      defaultMessage: 'No one works fully remotely',
    }),
    value: 'not-remote',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.remoteOptions.partiallyRemote',
      defaultMessage: 'Partially remote',
    }),
    subtitle: defineMessage({
      id: 'boarding.createOrg.remoteOptions.partiallyRemoteSubtitle',
      defaultMessage: 'Has an office, offers to work remotely',
    }),
    value: 'partially-remote',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.remoteOptions.fullyRemote',
      defaultMessage: 'Fully remote',
    }),
    subtitle: defineMessage({
      id: 'boarding.createOrg.remoteOptions.fullyRemoteSubtitle',
      defaultMessage: 'Does not have an office',
    }),
    value: 'full-remote',
  },
].map((x) => ({ ...x, id: x.value }))

export const ATTRIBUTION_OPTIONS = [
  {
    title: defineMessage({
      id: 'boarding.createOrg.howDoYouKnowUs.friendOrColleague',
      defaultMessage: 'Friend, family, or work colleague',
    }),
    value: 'friend-or-colleague',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.howDoYouKnowUs.search',
      defaultMessage: 'Search (Google...)',
    }),
    value: 'search',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.howDoYouKnowUs.onlineAdvertisement',
      defaultMessage: 'Online advertisement',
    }),
    value: 'advertisement',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.howDoYouKnowUs.blogPost',
      defaultMessage: 'Blog post',
    }),
    value: 'blog-post',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.howDoYouKnowUs.socialMediaPost',
      defaultMessage: 'Social media post',
    }),
    value: 'social-media',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.howDoYouKnowUs.other',
      defaultMessage: 'Other',
    }),
    value: 'other',
  },
].map((x) => ({ ...x, id: x.value }))

export const GOAL_OPTIONS = [
  {
    title: defineMessage({
      id: 'boarding.createOrg.goalOptions.kb',
      defaultMessage: 'Create a team knowledge base',
    }),
    value: 'knowledge-base',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.goalOptions.projectCollaboration',
      defaultMessage: 'Collaborate on a project',
    }),
    value: 'project-collaboration',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.goalOptions.meetingNotes',
      defaultMessage: 'Take meeting notes',
    }),
    value: 'meeting-notes',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.goalOptions.personalNotes',
      defaultMessage: 'Take personal notes',
    }),
    value: 'personal-notes',
  },
  {
    title: defineMessage({
      id: 'boarding.createOrg.goalOptions.other',
      defaultMessage: 'Other',
    }),
    value: 'other',
  },
].map((x) => ({ ...x, id: x.value }))
